import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  QUERIES,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { getHistoricoValoresEmpresa, getValoresEmpresa } from './_requests'
import { useQueryRequest } from './QueryRequestProvider'
import { useModal } from '../../../../../components'
import { useParams } from 'react-router-dom'
import { HistoricoValorEmpresaList, ValorEmpresaList } from './_models'

const QueryResponseContext = createResponseContext<HistoricoValorEmpresaList | ValorEmpresaList>(
  initialQueryResponse
)

export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()
  const { id } = useParams<{ id: string }>()

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  const queryFn =
    state.tab === 'historico'
      ? () => getHistoricoValoresEmpresa(query, Number(id))
      : () => getValoresEmpresa(query, Number(id))

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery([QUERIES.EMPRESAS_VALORES_LIST, id, query, isOpen, state.tab], queryFn, {
    cacheTime: 0,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    enabled: !isOpen,
  })

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
